export default "__VITE_ASSET__DDSc4R27__"